import styled from 'styled-components';

import JobOptions from '../InstallationModalCommon/JobOptions';
import AddToCartButton from '../InstallationModalCommon/AddToCartButton';
import InstallationOptions from './InstallationOptions/InstallationOptionsConnector';

import breakpoints, { breakpointsDesktopFirst } from '../../themes/breakpoints';

const buttonPadding = '2em';

export const FlexJobOptions = styled(JobOptions)`
flex: 1 0 0%;
min-height: min-content;
`;

export const FlexProjectDetails = styled.div`
display: flex;
flex-direction: column;
`;

export const FlexAddToCartButtonContainer = styled.div`
  padding: 0 ${buttonPadding} 1.5em ${buttonPadding};

  @media ${breakpointsDesktopFirst.tablet} {
    position: absolute;
    bottom: .5em;
    padding: 0 0;
    width: calc(100% - ${buttonPadding} - ${buttonPadding});
    left: ${buttonPadding};
    right: ${buttonPadding};
}
`;

export const FlexAddToCartButton = styled(AddToCartButton).attrs({ className: 'btn btn-primary' })`
    width: 100%;
`;

export const FlexInstallationOptions = styled(InstallationOptions)`
min-height: min-content;
flex: 1 0 0%;
`;

export const FlexModal = styled.div`
display: flex;
flex-direction: column;
flex-wrap: nowrap;
justify-content: space-between;
height: calc(100% - 3rem);
width: 100%;
min-height: min-content;
max-width: 100%;
overflow-y: auto;

@media ${breakpoints.desktopSmall} {
  flex-direction: row;
  flex-wrap: wrap;
  ${FlexProjectDetails} {
    order: 1;
    width: 55%;
  }
  ${FlexInstallationOptions} {
    order: 2;
    width: 45%;
    flex: 1 0;
  }
}
`;
